import { render, staticRenderFns } from "./demonstration.vue?vue&type=template&id=14fa11ba&scoped=true"
import script from "./demonstration.vue?vue&type=script&lang=js"
export * from "./demonstration.vue?vue&type=script&lang=js"
import style0 from "./demonstration.vue?vue&type=style&index=0&id=14fa11ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fa11ba",
  null
  
)

export default component.exports